'use client';

import ContactUsPage from '@/components/organisms/contact-us';
import React from 'react';

const ContactUsTastics = ({data}: any) => {
    const contactUsData = data.data.dataSource;
    
    return <ContactUsPage contactUsData={contactUsData} />
};

export default ContactUsTastics;